import moment from 'moment';
import { unmask, numberUnmask } from 'utils/unmask';
import { unSupportedStates } from 'utils/unSupportedStates';
import { get } from 'lodash';

export default {
  requestedLoanAmount: [
    'required',
    {
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
      },
    },
  ],
  customerDedicatedAccountBalance: [
    'required',
    {
      rule: 'string',
      isValid: input => (`${input}`.length ? true : 'This field is required'),
    },
  ],
  monthlySavingsAmount: [
    'required',
    {
      rule: 'string',
      isValid: input => (`${input}`.length ? true : 'This field is required'),
    },
  ],
  firstName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  lastName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  address: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  city: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  state: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return (unSupportedStates.indexOf(input) !== -1) ? `Currently we do not accept loan applications for residents of the state of ${input}` : true;
    },
  }],
  zipcode: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return input.replace('_', '').length < 5 ? 'Zipcode is not valid' : true;
      },
    },
  ],
  dateOfBirth: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        if (numberUnmask(input).length < 8) {
          return 'Date of Birth is not valid';
        }

        if (!moment(input, 'MM/DD/YYYY').isValid()) {
          return 'Date of Birth is not valid';
        }

        if ((moment.duration(moment(new Date()).diff(moment(input, 'MM-DD-YYYY'))).asYears()) < 18) {
          return 'must be over 18 years old';
        }

        if (parseInt(input.slice(-4), 10) < 1900) {
          return 'Please confirm date of birth';
        }
        return true;
      },
    },
  ],
  ssn: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        if (numberUnmask(input).length < 9) {
          return 'SSN is not valid';
        }

        const blockingSsns = [
          '078-05-1120',
          '219-09-9999',
          '111-11-1111',
          '222-22-2222',
          '333-33-3333',
          '444-44-4444',
          '555-55-5555',
          '666-66-6666',
          '777-77-7777',
          '888-88-8888',
          '999-99-9999',
          '123-45-6789',
        ];

        if (
          numberUnmask(input).substring(0, 3) === '000' ||
          numberUnmask(input).substring(3, 5) === '00' ||
          numberUnmask(input).substring(5, 9) === '0000' ||
          (Number(numberUnmask(input).substring(0, 3)) > 899 && Number(numberUnmask(input).substring(0, 3)) < 1000) ||
          blockingSsns.includes(input)

        ) {
          return 'SSN is not valid';
        }
      },
    },
  ],
  email: [
    'required',
    {
      rule: 'email',
      isValid: (input) => {
        const blokingEmails = [
          'none@none.com',
          'noemail@noemail.com',
          'noemail@gmail.com',
          'noemail@email.com',
          'none@NOEMAIL.com',
          'none@gmail.com',
          'none@yahoo.com',
          'no@no.com',
          'no@email.com',
          'noemail@yahoo.com',
          'test@test.com',
          'na@na.com',
          'noname@gmail.com',
          'no@gmail.com',
          'noemail@mail.com',
          'test@email.com',
          'unknown@yahoo.com',
          'non@non.com',
          'noemal@noemail.com',
          'none@email.com',
          'noname@email.com',
          'noemail@no.com',
          'non@none.com',
          'email@email.com',
          'nomail@gmail.com',
          'noemail@gimail.com',
          'noemail@aol.com',
          'na@gmail.com',
          'noemail@gmai.com',
          'noemail@noemai.com',
          'none@aol.com',
        ];

        return blokingEmails.includes(`${input}`.toLowerCase()) ? 'Email is not valid' : true;
      },
    },
  ],
  mobilePhone: [{
    rule: 'required',
    isValid: (input) => {
      const phoneNumbers = [
        '1111111111',
        '2222222222',
        '3333333333',
        '4444444444',
        '5555555555',
        '6666666666',
        '7777777777',
        '9999999999',
      ];

      if (!input) {
        return 'The input field is required';
      }

      const unmaskedInput = numberUnmask(input);

      if (unmaskedInput.length < 10) {
        return 'Phone number is not valid';
      }

      return (
        phoneNumbers.includes(unmaskedInput) ||
        (input && unmaskedInput.charAt(0) === '0') ||
        (input && unmaskedInput.charAt(0) === '1') ||
        (input && unmaskedInput.substring(3) === '0000000')
      ) ? 'Phone number is not valid' : true;
    },
  }],
  grossMonthlyIncome: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        return (Number(unmask(input)) > 41600 || Number(unmask(input)) <= 0) ? 'The amount should not exceed $41,600.' : true;
      },
    },
  ],
  employmentStatus: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  employerName: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }

      return true;
    },
  }],
  employmentYears: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }
    },
  }],
  occupation: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }

      return true;
    },
  }],
  housingExpense: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  consentToVerifyIncomeEmployment: [
    'required',
    {
      isValid: input => (
        input || 'The custom field is not valid'
      ),
    },
  ],
  employerPhone: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }

      const phoneNumbers = [
        '(111) 111-1111',
        '(222) 222-2222',
        '(333) 333-3333',
        '(444) 444-4444',
        '(555) 555-5555',
        '(666) 666-6666',
        '(777) 777-7777',
        '(999) 999-9999',
      ];

      if (numberUnmask(input).length < 10) {
        return 'Phone number is not valid';
      }

      return (
        phoneNumbers.includes(input) ||
        (input && input.charAt(1) === '0') ||
        (input && input.charAt(1) === '1') ||
        (input && input.substring(6) === '000-0000')
      ) ? 'Phone number is not valid' : true;
    },
  }],
  consentElectronicCommunication: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return true;
      },
    },
  ],
  consentToTermsAndConditions: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return true;
      },
    },
  ],
};
